import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    label: null,
    value: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {





function onChange(e: Event) {
	const target = e.target as HTMLInputElement | null;
	emit('input', !!target?.checked);
}

return { __sfc: true,emit, onChange }
}

})